import { render } from "./BomValidationResultsErrorTypesTabs.vue?vue&type=template&id=0862584a&scoped=true"
import script from "./BomValidationResultsErrorTypesTabs.vue?vue&type=script&lang=js"
export * from "./BomValidationResultsErrorTypesTabs.vue?vue&type=script&lang=js"

import "./BomValidationResultsErrorTypesTabs.vue?vue&type=style&index=0&id=0862584a&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0862584a"]])

export default __exports__
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTab});
